/**
 * DecantsLab Cart Actions
 * Archivo: assets/dl-cart-actions.js
 *
 * Objetivo:
 * - Centralizar Add to Cart.
 * - Actualizar cart drawer.
 * - Actualizar cart icon bubble.
 * - Sincronizar regalos automáticos.
 * - Actualizar barra de beneficios del drawer.
 * - Actualizar barra PDP.
 * - Reemplazar scripts duplicados sin usar window.fetch monkeypatch.
 */

(function () {
  'use strict';

  if (window.DecantsCart && window.DecantsCart.__initialized) return;

  const ROOT =
    window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/';

  const ROUTES = window.routes || {};

  const CONFIG = {
    debug: false,

    gifts: {
      arabe: 47402847207562,
      disenador: 47402850418826,
      nicho: 47402850877578,
      ebook: 49449992159370,
    },

    goals: [
      { goal: 19990, label: 'Ebook de regalo', pdpLabel: 'EBOOK GRATIS' },
      { goal: 39990, label: 'Decant Árabe', pdpLabel: 'DECANT ÁRABE' },
      { goal: 64990, label: 'Envío gratuito', pdpLabel: 'ENVÍO GRATUITO' },
      { goal: 79990, label: 'Decant Diseñador', pdpLabel: 'DECANT DISEÑADOR' },
      { goal: 110000, label: 'Decant Nicho', pdpLabel: 'DECANT NICHO' },
    ],

    giftProperties: {
      'Tipo de ítem': 'REGALO PROMOCIÓN',
      'Detalle promoción': 'Promoción por monto de compra',
    },
  };

  CONFIG.allGiftIds = Object.values(CONFIG.gifts)
    .filter(Boolean)
    .map(function (id) {
      return Number(id);
    });

  const state = {
    cartCache: null,
    cartCacheAt: 0,
    isSyncingGifts: false,
    isRendering: false,
    lastActiveElement: null,
  };

  function log() {
    if (!CONFIG.debug) return;
    console.log('[DecantsCart]', ...arguments);
  }

  function moneyCLP(value) {
    return '$' + Math.round(Number(value) || 0).toLocaleString('es-CL');
  }

  function cartAddUrl() {
    return ROUTES.cart_add_url || ROOT + 'cart/add.js';
  }

  function cartChangeUrl() {
    return ROUTES.cart_change_url || ROOT + 'cart/change.js';
  }

  function cartUpdateUrl() {
    return ROUTES.cart_update_url || ROOT + 'cart/update.js';
  }

  function cartUrl() {
    return ROUTES.cart_url || ROOT + 'cart';
  }

  function cartJsonUrl() {
    return ROOT + 'cart.js';
  }

  function getCartDrawer() {
    return document.querySelector('cart-drawer');
  }

  function getCartIconBubble() {
    return document.getElementById('cart-icon-bubble');
  }
  function setCartDrawerEmptyState(isEmpty) {
    const drawer = getCartDrawer();
    if (!drawer) return;

    drawer.classList.toggle('is-empty', Boolean(isEmpty));

    const drawerInner = drawer.querySelector('.drawer__inner');
    if (drawerInner) {
        drawerInner.classList.toggle('is-empty', Boolean(isEmpty));
    }

    const drawerItems = drawer.querySelector('cart-drawer-items');
    if (drawerItems) {
        drawerItems.classList.toggle('is-empty', Boolean(isEmpty));
    }
  }

  function getSectionIds() {
    const drawer = getCartDrawer();

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      return drawer.getSectionsToRender().map(function (section) {
        return section.id;
      });
    }

    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function appendSectionsToFormData(formData) {
    if (!formData.has('sections')) {
      formData.append('sections', getSectionIds().join(','));
    }

    if (!formData.has('sections_url')) {
      formData.append('sections_url', window.location.pathname);
    }

    return formData;
  }

  function appendSectionsToPayload(payload) {
    const nextPayload = Object.assign({}, payload || {});

    if (!nextPayload.sections) {
      nextPayload.sections = getSectionIds();
    }

    if (!nextPayload.sections_url) {
      nextPayload.sections_url = window.location.pathname;
    }

    return nextPayload;
  }

  async function fetchJSON(url, options) {
    const response = await fetch(url, options);
    const data = await response.json().catch(function () {
      return {};
    });

    if (!response.ok || data.status) {
      const error = new Error(data.description || data.message || 'Error de carrito');
      error.response = data;
      throw error;
    }

    return data;
  }

  async function rawPostJSON(url, payload) {
    return fetchJSON(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(payload),
    });
  }

  async function getCart(options) {
    const opts = Object.assign({ force: false }, options || {});
    const now = Date.now();

    if (!opts.force && state.cartCache && now - state.cartCacheAt < 800) {
      return state.cartCache;
    }

    const cart = await fetchJSON(cartJsonUrl(), {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    state.cartCache = cart;
    state.cartCacheAt = Date.now();

    return cart;
  }

  async function fetchSections() {
    const sections = getSectionIds().join(',');
    const url = cartUrl() + '?sections=' + encodeURIComponent(sections);

    const response = await fetch(url, {
      method: 'GET',
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
      },
    });

    if (!response.ok) {
      throw new Error('No se pudieron refrescar las secciones del carrito');
    }

    return response.json();
  }

  function parseHTML(html) {
    return new DOMParser().parseFromString(html, 'text/html');
  }

  function getSectionInnerHTML(html, selector) {
    if (!html) return '';

    const doc = parseHTML(html);
    const target = doc.querySelector(selector || '.shopify-section');

    return target ? target.innerHTML : '';
  }

  function renderSectionsManually(sections) {
    if (!sections) return false;

    const drawer = getCartDrawer();

    if (drawer && typeof drawer.getSectionsToRender === 'function') {
      drawer.getSectionsToRender().forEach(function (section) {
        const html = sections[section.id];
        if (!html) return;

        const sectionElement = section.selector
          ? document.querySelector(section.selector)
          : document.getElementById(section.id);

        if (!sectionElement) return;

        sectionElement.innerHTML = getSectionInnerHTML(html, section.selector);
      });

      return true;
    }

    const cartIcon = getCartIconBubble();
    if (cartIcon && sections['cart-icon-bubble']) {
      cartIcon.innerHTML = getSectionInnerHTML(sections['cart-icon-bubble']);
      return true;
    }

    return false;
  }

  function renderCartSections(sections, options) {
    const opts = Object.assign({ openDrawer: false }, options || {});
    const drawer = getCartDrawer();

    if (!sections) return false;

    if (opts.openDrawer && drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        sections: sections,
        id: null,
      });

      return true;
    }

    return renderSectionsManually(sections);
  }

  async function refreshCartUI(options) {
    const opts = Object.assign(
      {
        openDrawer: false,
        sections: null,
        cart: null,
      },
      options || {}
    );

    if (state.isRendering) return;
    state.isRendering = true;

    try {
      const sections = opts.sections || (await fetchSections());

      renderCartSections(sections, {
        openDrawer: opts.openDrawer,
      });

      const cart = opts.cart || (await getCart({ force: true }));
      updateBenefitsUI(cart);
      updatePdpProgressUI(cart);
    } finally {
      state.isRendering = false;
    }
  }

  function publishThemeCartUpdate(source, cartData, productVariantId) {
    try {
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartUpdate
      ) {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: source || 'decants-cart',
          productVariantId: productVariantId,
          cartData: cartData,
        });
      }
    } catch (error) {
      log('No se pudo publicar PUB_SUB_EVENTS.cartUpdate', error);
    }
  }

  function publishThemeCartError(source, errorData, productVariantId) {
    try {
      if (
        typeof publish === 'function' &&
        typeof PUB_SUB_EVENTS !== 'undefined' &&
        PUB_SUB_EVENTS.cartError
      ) {
        publish(PUB_SUB_EVENTS.cartError, {
          source: source || 'decants-cart',
          productVariantId: productVariantId,
          errors: errorData.errors || errorData.description || errorData.message,
          message: errorData.message || errorData.description,
        });
      }
    } catch (error) {
      log('No se pudo publicar PUB_SUB_EVENTS.cartError', error);
    }
  }

  function emitCartUpdated(detail) {
    const payload = Object.assign({ __decantsCart: true }, detail || {});

    document.dispatchEvent(new CustomEvent('decants:cart-updated', { detail: payload }));
    document.dispatchEvent(new CustomEvent('cartUpdate:finished', { detail: payload }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: payload }));

    document.documentElement.dispatchEvent(
      new CustomEvent('cart:refresh', {
        bubbles: true,
        detail: payload,
      })
    );

    publishThemeCartUpdate(payload.source, payload.cart || payload.response, payload.productVariantId);
  }

  function emitCartError(error, detail) {
    const payload = Object.assign({}, detail || {});
    const response = error && error.response ? error.response : error || {};

    document.dispatchEvent(
      new CustomEvent('decants:cart-error', {
        detail: Object.assign(payload, { error: response }),
      })
    );

    publishThemeCartError(payload.source, response, payload.productVariantId);
  }

  function progressPercent(totalCLP) {
    const goals = CONFIG.goals;

    if (totalCLP <= 0) return 0;

    if (totalCLP <= goals[0].goal) {
      return (totalCLP / goals[0].goal) * 20;
    }

    for (let i = 1; i < goals.length; i += 1) {
      const previous = goals[i - 1].goal;
      const current = goals[i].goal;

      if (totalCLP <= current) {
        return i * 20 + ((totalCLP - previous) / (current - previous)) * 20;
      }
    }

    return 100;
  }

  function getNextGoal(totalCLP) {
    return (
      CONFIG.goals.find(function (goal) {
        return totalCLP < goal.goal;
      }) || CONFIG.goals[CONFIG.goals.length - 1]
    );
  }

  function updateBenefitsUI(cart) {
    if (!cart) return;

    const bar = document.getElementById('benefits-bar-fill');
    const totalCLP = Number(cart.total_price || 0) / 100;

    if (bar) {
      bar.style.width = Math.max(progressPercent(totalCLP), 0) + '%';
    }

    CONFIG.goals.forEach(function (goal) {
      const circle = document.querySelector(
        '.benefits-step[data-goal="' + goal.goal + '"] .benefits-circle'
      );

      if (circle) {
        circle.classList.toggle('active', totalCLP >= goal.goal);
      }
    });

    const titleEl = document.querySelector('.benefits-title');

    if (titleEl) {
      if (totalCLP >= 110000) {
        titleEl.innerHTML = '<strong>¡Desbloqueaste todos los regalos!</strong>';
      } else {
        const nextGoal = getNextGoal(totalCLP);
        const remaining = Math.max(nextGoal.goal - totalCLP, 0);

        let labelText = nextGoal.label;

        if (nextGoal.goal === 19990) labelText = 'sumar tu Ebook de regalo';
        if (nextGoal.goal === 39990) labelText = 'tu primer Decant de regalo';
        if (nextGoal.goal === 64990) labelText = 'Envío gratuito';
        if (nextGoal.goal === 79990) labelText = 'subir tu decant a Diseñador';
        if (nextGoal.goal === 110000) labelText = 'subir tu decant a Nicho';

        titleEl.innerHTML =
          'Estás a <span id="benefits-remaining">' +
          moneyCLP(remaining) +
          '</span> de <span id="benefits-current-label">' +
          labelText +
          '</span>';
      }
    }
  }

  function updatePdpProgressUI(cart) {
    if (!cart) return;

    const bars = document.querySelectorAll('pdp-progress-bar');
    if (!bars.length) return;

    const totalCLP = Number(cart.total_price || 0) / 100;
    const percent = Math.max(progressPercent(totalCLP), totalCLP > 0 ? 1 : 0);

    bars.forEach(function (component) {
      const fill = component.querySelector('.pdp-bar-fill');
      const title = component.querySelector('#pdp-dynamic-title');

      if (fill) {
        fill.style.setProperty('width', percent + '%', 'important');
      }

      component.querySelectorAll('.pdp-cro-step').forEach(function (step) {
        const goal = Number(step.getAttribute('data-pdp-goal') || 0);
        step.classList.toggle('achieved', totalCLP >= goal);
      });

      if (title) {
        if (totalCLP >= 110000) {
          title.innerHTML =
            '<span class="pdp-cro-highlight">¡FELICIDADES!</span> HAS ALCANZADO EL <span class="pdp-cro-reward-name">NIVEL MÁXIMO</span>';
        } else {
          const nextGoal = getNextGoal(totalCLP);
          const remaining = Math.max(nextGoal.goal - totalCLP, 0);

          title.innerHTML =
            'ESTÁS A <span class="pdp-cro-highlight">' +
            moneyCLP(remaining) +
            '</span> DE <span class="pdp-cro-reward-name">' +
            nextGoal.pdpLabel +
            '</span>';
        }
      }
    });
  }

  function computeDesiredGiftIds(totalCLP) {
    const gifts = [];

    if (totalCLP >= 110000) {
      gifts.push(CONFIG.gifts.nicho);
    } else if (totalCLP >= 79990) {
      gifts.push(CONFIG.gifts.disenador);
    } else if (totalCLP >= 39990) {
      gifts.push(CONFIG.gifts.arabe);
    }

    if (CONFIG.gifts.ebook && totalCLP >= 19990) {
      gifts.push(CONFIG.gifts.ebook);
    }

    return gifts.filter(Boolean).map(Number);
  }

  function giftPropertiesForVariant(variantId) {
    const properties = Object.assign({}, CONFIG.giftProperties);

    if (Number(variantId) === Number(CONFIG.gifts.ebook)) {
      properties._Ebook = 'Active';
    }

    return properties;
  }

  async function updateGiftItems(cart) {
    if (!cart || !cart.items) {
      return {
        changed: false,
        cart: cart,
      };
    }

    if (state.isSyncingGifts) {
      return {
        changed: false,
        cart: cart,
      };
    }

    state.isSyncingGifts = true;

    try {
      const totalCLP = Number(cart.total_price || 0) / 100;
      const desiredIds = computeDesiredGiftIds(totalCLP);
      const desiredSet = new Set(desiredIds);
      const foundDesiredIds = new Set();
      const updates = {};
      let changed = false;

      const giftItems = cart.items.filter(function (item) {
        return CONFIG.allGiftIds.includes(Number(item.variant_id));
      });

      giftItems.forEach(function (item) {
        const variantId = Number(item.variant_id);
        const shouldExist = desiredSet.has(variantId);
        const alreadyFound = foundDesiredIds.has(variantId);

        if (!shouldExist || alreadyFound) {
          updates[item.key] = 0;
          changed = true;
          return;
        }

        foundDesiredIds.add(variantId);

        if (Number(item.quantity) !== 1) {
          updates[item.key] = 1;
          changed = true;
        }
      });

      if (Object.keys(updates).length) {
        await rawPostJSON(cartUpdateUrl(), { updates: updates });
      }

      const toAdd = desiredIds.filter(function (variantId) {
        return !foundDesiredIds.has(Number(variantId));
      });

      if (toAdd.length) {
        changed = true;

        await rawPostJSON(cartAddUrl(), {
          items: toAdd.map(function (variantId) {
            return {
              id: Number(variantId),
              quantity: 1,
              properties: giftPropertiesForVariant(variantId),
            };
          }),
        });
      }

      if (!changed) {
        return {
          changed: false,
          cart: cart,
        };
      }

      const newCart = await getCart({ force: true });

      return {
        changed: true,
        cart: newCart,
      };
    } finally {
      state.isSyncingGifts = false;
    }
  }

  async function syncGiftsAndBenefits(options) {
    const opts = Object.assign(
      {
        render: true,
        openDrawer: false,
        source: 'sync-gifts-and-benefits',
      },
      options || {}
    );

    const cart = await getCart({ force: true });
    updateBenefitsUI(cart);
    updatePdpProgressUI(cart);

    const result = await updateGiftItems(cart);
    const finalCart = result.cart || cart;

    updateBenefitsUI(finalCart);
    updatePdpProgressUI(finalCart);

    if (opts.render && result.changed) {
      const sections = await fetchSections();

      await refreshCartUI({
        sections: sections,
        cart: finalCart,
        openDrawer: opts.openDrawer,
      });
    }

    return finalCart;
  }
  async function hydrateCartAfterMutation(options) {
    const opts = Object.assign(
        {
        source: 'cart-mutation',
        response: null,
        productVariantId: null,
        openDrawer: false,
        renderIfGiftChanged: true,
        },
        options || {}
    );

    let cart = await getCart({ force: true });

    updateBenefitsUI(cart);
    updatePdpProgressUI(cart);

    const giftResult = await updateGiftItems(cart);
    cart = giftResult.cart || cart;

    updateBenefitsUI(cart);
    updatePdpProgressUI(cart);

    if (opts.renderIfGiftChanged && giftResult.changed) {
        const sections = await fetchSections();

        await refreshCartUI({
        sections: sections,
        cart: cart,
        openDrawer: opts.openDrawer,
        });
    }

    emitCartUpdated({
        source: opts.source,
        response: opts.response,
        cart: cart,
        productVariantId: opts.productVariantId,
    });

    return cart;
  }
  let themeCartSyncTimer = null;

    function afterThemeCartChange(cartState, options) {
    const opts = Object.assign(
        {
        source: 'theme-cart-change',
        openDrawer: false,
        },
        options || {}
    );

    if (!cartState) return;

    /**
     * cart.js ya recibe un parsedState con total_price, item_count, items, sections.
     * Usamos ese estado inmediatamente para pintar beneficios sin esperar /cart.js.
     */
    state.cartCache = cartState;
    state.cartCacheAt = Date.now();
    setCartDrawerEmptyState(Number(cartState.item_count || 0) === 0);

    updateBenefitsUI(cartState);
    updatePdpProgressUI(cartState);

    window.clearTimeout(themeCartSyncTimer);

    themeCartSyncTimer = window.setTimeout(function () {
        hydrateCartAfterMutation({
        source: opts.source,
        response: cartState,
        productVariantId: null,
        openDrawer: opts.openDrawer,
        renderIfGiftChanged: true,
        }).catch(function (error) {
        log(error);
        });
    }, 180);
    }


  async function completeMutation(response, options) {
    const opts = Object.assign(
        {
        openDrawer: true,
        source: 'decants-cart',
        productVariantId: null,
        },
        options || {}
    );
    setCartDrawerEmptyState(false);

    /**
     * IMPORTANTE:
     * Primero renderizamos y abrimos el drawer usando las sections que ya vienen
     * desde /cart/add.js. Esto evita esperar la sincronización de regalos.
     */
    if (response && response.sections) {
        renderCartSections(response.sections, {
        openDrawer: opts.openDrawer,
        });
    } else {
        refreshCartUI({
        openDrawer: opts.openDrawer,
        }).catch(function (error) {
        log(error);
        });
    }

    /**
     * Luego hidratamos beneficios/regalos en segundo plano.
     * Esto evita que el usuario espere 5-6 segundos para ver el drawer.
     */
    window.setTimeout(function () {
        hydrateCartAfterMutation({
        source: opts.source,
        response: response,
        productVariantId: opts.productVariantId,
        openDrawer: false,
        }).catch(function (error) {
        log(error);
        });
    }, 80);

    return {
        response: response,
        cart: null,
    };
  }

  async function addForm(form, options) {
    const opts = Object.assign(
      {
        openDrawer: true,
        source: 'add-form',
      },
      options || {}
    );

    if (!form) throw new Error('Formulario inválido');

    state.lastActiveElement = document.activeElement;

    const drawer = getCartDrawer();
    if (drawer && typeof drawer.setActiveElement === 'function') {
      drawer.setActiveElement(state.lastActiveElement);
    }

    const formData = appendSectionsToFormData(new FormData(form));
    const productVariantId = formData.get('id');

    try {
      const response = await fetchJSON(cartAddUrl(), {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
      });

      return completeMutation(response, {
        openDrawer: opts.openDrawer,
        source: opts.source,
        productVariantId: productVariantId,
      });
    } catch (error) {
      emitCartError(error, {
        source: opts.source,
        productVariantId: productVariantId,
      });

      throw error;
    }
  }

  async function addItem(variantId, quantity, properties, options) {
    const opts = Object.assign(
      {
        openDrawer: true,
        source: 'add-item',
      },
      options || {}
    );

    const payload = appendSectionsToPayload({
      id: Number(variantId),
      quantity: Number(quantity || 1),
      properties: properties || {},
    });

    try {
      const response = await rawPostJSON(cartAddUrl(), payload);

      return completeMutation(response, {
        openDrawer: opts.openDrawer,
        source: opts.source,
        productVariantId: variantId,
      });
    } catch (error) {
      emitCartError(error, {
        source: opts.source,
        productVariantId: variantId,
      });

      throw error;
    }
  }

  async function addItems(items, options) {
    const opts = Object.assign(
      {
        openDrawer: true,
        source: 'add-items',
      },
      options || {}
    );

    const cleanItems = (items || []).map(function (item) {
      return {
        id: Number(item.id || item.variant_id),
        quantity: Number(item.quantity || 1),
        properties: item.properties || {},
      };
    });

    const payload = appendSectionsToPayload({
      items: cleanItems,
    });

    try {
      const response = await rawPostJSON(cartAddUrl(), payload);

      return completeMutation(response, {
        openDrawer: opts.openDrawer,
        source: opts.source,
        productVariantId: cleanItems[0] ? cleanItems[0].id : null,
      });
    } catch (error) {
      emitCartError(error, {
        source: opts.source,
      });

      throw error;
    }
  }

  async function changeLine(line, quantity, options) {
    const opts = Object.assign(
      {
        openDrawer: false,
        source: 'change-line',
      },
      options || {}
    );

    const payload = appendSectionsToPayload({
      line: Number(line),
      quantity: Number(quantity),
    });

    try {
      const response = await rawPostJSON(cartChangeUrl(), payload);

      return completeMutation(response, {
        openDrawer: opts.openDrawer,
        source: opts.source,
      });
    } catch (error) {
      emitCartError(error, {
        source: opts.source,
      });

      throw error;
    }
  }

  async function updateCart(updates, options) {
    const opts = Object.assign(
      {
        openDrawer: false,
        source: 'update-cart',
      },
      options || {}
    );

    const payload = appendSectionsToPayload({
      updates: updates || {},
    });

    try {
      const response = await rawPostJSON(cartUpdateUrl(), payload);

      return completeMutation(response, {
        openDrawer: opts.openDrawer,
        source: opts.source,
      });
    } catch (error) {
      emitCartError(error, {
        source: opts.source,
      });

      throw error;
    }
  }

  function setButtonLoading(button, isLoading, text) {
    if (!button) return;

    if (!button.dataset.dlOriginalHtml) {
      button.dataset.dlOriginalHtml = button.innerHTML;
    }

    button.disabled = Boolean(isLoading);
    button.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
    button.classList.toggle('loading', Boolean(isLoading));

    const spinner =
      button.querySelector('.loading__spinner') ||
      (button.closest('product-form') && button.closest('product-form').querySelector('.loading__spinner'));

    if (spinner) {
      spinner.classList.toggle('hidden', !isLoading);
    }

    if (text) {
      button.innerHTML = text;
    }

    if (!isLoading && !text && button.dataset.dlOriginalHtml) {
      button.innerHTML = button.dataset.dlOriginalHtml;
    }
  }

  function restoreButton(button, delay) {
    if (!button) return;

    const restore = function () {
      button.disabled = false;
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');

      if (button.dataset.dlOriginalHtml) {
        button.innerHTML = button.dataset.dlOriginalHtml;
      }

      const spinner =
        button.querySelector('.loading__spinner') ||
        (button.closest('product-form') && button.closest('product-form').querySelector('.loading__spinner'));

      if (spinner) {
        spinner.classList.add('hidden');
      }
    };

    if (delay) {
      window.setTimeout(restore, delay);
    } else {
      restore();
    }
  }

  function openCartDrawer(triggeredBy) {
    const drawer = getCartDrawer();

    if (drawer && typeof drawer.open === 'function') {
      drawer.open(triggeredBy || state.lastActiveElement || undefined);
      return true;
    }

    const cartTrigger = document.querySelector(
      '#cart-icon-bubble, .header__icon--cart, [data-drawer-trigger="cart"], a[href="/cart"]'
    );

    if (cartTrigger) {
      cartTrigger.click();
      return true;
    }

    return false;
  }

  function closeCartDrawer() {
    const drawer = getCartDrawer();

    if (drawer && typeof drawer.close === 'function') {
      drawer.close();
    }
  }

  function initDrawerScrollLock() {
    const drawer = getCartDrawer();
    if (!drawer || drawer.dataset.dlScrollLockInitialized === 'true') return;

    drawer.dataset.dlScrollLockInitialized = 'true';

    const handle = function () {
      const isActive = drawer.classList.contains('active') || drawer.hasAttribute('open');

      document.body.classList.toggle('overflow-hidden', isActive);
      document.documentElement.classList.toggle('overflow-hidden', isActive);

      if (isActive) {
        document.body.style.height = '100vh';
      } else {
        document.body.style.height = '';
      }
    };

    const observer = new MutationObserver(handle);

    observer.observe(drawer, {
      attributes: true,
      attributeFilter: ['class', 'open'],
    });

    handle();
  }

  function initLazyCartState() {
    const shouldFetchInitialCart = function () {
      if (document.querySelector('pdp-progress-bar') && window.matchMedia('(min-width: 769px)').matches) {
        return true;
      }

      if (document.querySelector('#benefits-bar-fill') && getCartDrawer() && getCartDrawer().classList.contains('active')) {
        return true;
      }

      return false;
    };

    const run = function () {
      if (!shouldFetchInitialCart()) return;

      syncGiftsAndBenefits({
        render: false,
        source: 'initial-state',
      }).catch(function (error) {
        log(error);
      });
    };

    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(run, { timeout: 1600 });
    } else {
      window.setTimeout(run, 800);
    }

    document.addEventListener(
      'click',
      function (event) {
        if (
          !event.target.closest(
            '#cart-icon-bubble, .header__icon--cart, [data-drawer-trigger="cart"], a[href="/cart"]'
          )
        ) {
          return;
        }

        syncGiftsAndBenefits({
          render: true,
          openDrawer: false,
          source: 'drawer-open-sync',
        }).catch(function (error) {
          log(error);
        });
      },
      { capture: true }
    );
  }

  function initExternalCartEvents() {
    const externalSync = function (event) {
      if (event && event.detail && event.detail.__decantsCart) return;

      syncGiftsAndBenefits({
        render: true,
        openDrawer: false,
        source: 'external-cart-event',
      }).catch(function (error) {
        log(error);
      });
    };

    document.addEventListener('cartUpdate:finished', externalSync);
    document.addEventListener('ajaxProduct:added', externalSync);
  }

  if (!customElements.get('pdp-progress-bar')) {
    customElements.define(
      'pdp-progress-bar',
      class PdpProgressBar extends HTMLElement {
        connectedCallback() {
          if (this.dataset.dlInitialized === 'true') return;

          this.dataset.dlInitialized = 'true';

          if (window.matchMedia('(max-width: 768px)').matches) return;

          getCart({ force: false })
            .then(function (cart) {
              updatePdpProgressUI(cart);
            })
            .catch(function (error) {
              log(error);
            });
        }
      }
    );
  }

  if (!customElements.get('product-form')) {
    customElements.define(
      'product-form',
      class ProductForm extends HTMLElement {
        constructor() {
          super();

          this.form = this.querySelector('form');
          this.submitButton = this.querySelector('[type="submit"]');
          this.submitButtonText = this.submitButton ? this.submitButton.querySelector('span') : null;
          this.hideErrors = this.dataset.hideErrors === 'true';
          this.error = false;
          this.soldOut = false;

          if (this.variantIdInput) {
            this.variantIdInput.disabled = false;
          }

          if (document.querySelector('cart-drawer') && this.submitButton) {
            this.submitButton.setAttribute('aria-haspopup', 'dialog');
          }

          if (this.form) {
            this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
          }
        }

        async onSubmitHandler(event) {
          event.preventDefault();

          if (!this.submitButton || this.submitButton.getAttribute('aria-disabled') === 'true') {
            return;
          }

          this.handleErrorMessage();
          state.lastActiveElement = document.activeElement;

          setButtonLoading(this.submitButton, true);

          try {
            const result = await addForm(this.form, {
              openDrawer: true,
              source: 'product-form',
            });

            this.error = false;
            return result;
          } catch (error) {
            this.error = true;

            const response = error && error.response ? error.response : error || {};
            const message = response.description || response.message || 'No se pudo agregar este producto.';

            this.handleErrorMessage(message);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');

            if (soldOutMessage && this.submitButtonText) {
              this.soldOut = true;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
            }
          } finally {
            if (this.soldOut) {
              this.submitButton.classList.remove('loading');

              const spinner =
                this.submitButton.querySelector('.loading__spinner') || this.querySelector('.loading__spinner');

              if (spinner) {
                spinner.classList.add('hidden');
              }
            } else {
              restoreButton(this.submitButton);
            }
          }
        }

        handleErrorMessage(errorMessage) {
          if (this.hideErrors) return;

          this.errorMessageWrapper =
            this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');

          if (!this.errorMessageWrapper) return;

          this.errorMessage =
            this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

          this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

          if (errorMessage && this.errorMessage) {
            this.errorMessage.textContent = errorMessage;
          }
        }

        toggleSubmitButton(disable, text) {
          if (!this.submitButton) return;

          if (disable) {
            this.submitButton.setAttribute('disabled', 'disabled');

            if (text && this.submitButtonText) {
              this.submitButtonText.textContent = text;
            }
          } else {
            this.submitButton.removeAttribute('disabled');

            if (this.submitButtonText && window.variantStrings) {
              this.submitButtonText.textContent = window.variantStrings.addToCart;
            }
          }
        }

        get variantIdInput() {
          return this.form ? this.form.querySelector('[name="id"]') : null;
        }
      }
    );
  }

  window.DecantsCart = {
    __initialized: true,
    config: CONFIG,
    state: state,

    getCart: getCart,
    addForm: addForm,
    addItem: addItem,
    addItems: addItems,
    changeLine: changeLine,
    updateCart: updateCart,
    afterThemeCartChange: afterThemeCartChange,

    refreshCartUI: refreshCartUI,
    syncGiftsAndBenefits: syncGiftsAndBenefits,
    updateBenefitsUI: updateBenefitsUI,
    updatePdpProgressUI: updatePdpProgressUI,

    openCartDrawer: openCartDrawer,
    closeCartDrawer: closeCartDrawer,

    setButtonLoading: setButtonLoading,
    restoreButton: restoreButton,
  };

  window.syncGiftsAndBenefits = syncGiftsAndBenefits;

  window.updateBenefits = function () {
    return getCart({ force: true }).then(function (cart) {
      updateBenefitsUI(cart);
      updatePdpProgressUI(cart);
      return cart;
    });
  };

  document.addEventListener('DOMContentLoaded', function () {
    initDrawerScrollLock();
    initLazyCartState();
    initExternalCartEvents();
  });
})();